import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { GuiaMedicare } from './pages/GuiaMedicare';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/guia-medicare" element={<GuiaMedicare data-id="element-6" />} data-id="element-5" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-8" />} data-id="element-7" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}